import React from 'react';
import {useHistory} from 'react-router'
import {Container, Dialog, Grid, makeStyles, Paper, Typography} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import {MuiThemeProvider, responsiveFontSizes} from '@material-ui/core/styles';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Edit from './Edit'
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../../API/customAxios";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {getMuiTheme, tableStyle, tableTheme} from "../../UIComponent/CommonStyle"
import MultiSelctUpdate from "./Edit/components/MultiSelectUpdate";

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));
const thisTheme = responsiveFontSizes(tableTheme);

export default function ApproversConfig() {
    const classes = useStyles();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const [submitCompletePopup, setCompletePopupOpen] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [selectedEmployeeIDs, setSelectedEmployeeIDs] = React.useState([]);
    const [selectedEmployeeNames, setSelectedEmployeeNames] = React.useState([]);

    React.useEffect(() => {
        customAxios.get(`/get_employee_approvers`)
            .then(res => {
                const employee = [];
                for (let i = 0; i < res.data.length; i++) {
                    employee.push({
                        id: `${res.data[i].id}`,
                        staffNo: `${res.data[i].staff_no}`,
                        employee: `${res.data[i].employee_name}`,
                        position: `${res.data[i].position}`,
                        location: `${res.data[i].location ? res.data[i].location.name : ''}`,
                        department: `${res.data[i].department ? res.data[i].department.name : ''}`,
                        firstApprover: `${res.data[i].approver && res.data[i].approver.first_approver_employee ? res.data[i].approver.first_approver_employee.employee_name : ''}`,
                        secondApprover: `${res.data[i].approver && res.data[i].approver.second_approver_employee ? res.data[i].approver.second_approver_employee.employee_name : ''}`,
                        active: `${res.data[i].active_label}`,
                    });
                }
                setData(employee);
                setShowCompetent(true);
            }, error => {
                if (error.response.status === 401) {
                    history.push('/home');
                }
            });
    }, []);

    const handleOpen = (id) => {
        setShowId(id)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleCompletePopupClose = () => {
        setCompletePopupOpen(false);
    };

    const updateApproverRecord = (values) => {
        setCompletePopupOpen(true);
        const tempDatas = [...data];
        tempDatas.forEach((element) => {
            if (element.id === values.showId) {
                element.firstApprover = values.firstApproverName;
                element.secondApprover = values.secondApproverName;
            }
        })
        setData(tempDatas);
    };

    function getCurrentDate() {
        const newDate = new Date()
        return moment(newDate).format(window.global.displayFormat);
    }

    const handleRowClick = async (rowData, rowMeta) => {
        let selectedRecord = [];
        setSelectedEmployeeNames([]);
        for (let row of rowMeta) {
            selectedRecord.push(parseInt(getEmployeeIDByIndex(row['dataIndex'])));
            setSelectedEmployeeNames(prev => [...prev, data[row['dataIndex']]['employee']]);

        }
        setSelectedEmployeeIDs(selectedRecord);
    };

    const getEmployeeIDByIndex = (dataIndex) => {
        return data[dataIndex]['id'];
    }

    const updateTable = (selectedApproverName, updateAction) => {
        let newData = [...data];
        newData.forEach((employeeData) => {
            if (selectedEmployeeIDs.includes(parseInt(employeeData.id)) && updateAction === 'ChangeFirstApprover') {
                employeeData.firstApprover = selectedApproverName;
            }
            if (selectedEmployeeIDs.includes(parseInt(employeeData.id)) && updateAction === 'ChangeSecondApprover') {
                employeeData.secondApprover = selectedApproverName;
            }
            if (selectedEmployeeIDs.includes(parseInt(employeeData.id)) && updateAction === 'RemoveSecondApprover') {
                employeeData.secondApprover = '';
            }
        })
        setData(newData);
    }

    const options = {
        filterType: 'checkbox',
        selectableRows: 'multiple',
        elevation: 1,
        print: false,
        search: false,
        downloadOptions: {
            filename: "Approver_Config_" + getCurrentDate() + ".csv",
            separator: ","
        },
        textLabels: {
            body: {
                noMatch: 'No matching records found',
            },
        },
        selectableRowsOnClick: false,
        onRowSelectionChange: handleRowClick,
        selectToolbarPlacement: 'none'
    };
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
                sort: true,
                display: false,
                download: false,
            }
        },
        {
            name: "staffNo",
            label: "Staff No.",
            options: {
                filter: true,
                sort: true,
                filterType: "textField",
            }
        },
        {
            name: "employee",
            label: "Employee",
            options: {
                filter: true,
                sort: true,
                filterType: "textField",
            }
        },
        {
            name: "position",
            label: "Position",
            options: {
                filter: true,
                sort: false,
                filterType: "textField",
            }
        },
        {
            name: "location",
            label: "Location",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "department",
            label: "Department",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "firstApprover",
            label: "First Approver",
            options: {
                filter: true,
                sort: false,
                filterType: "textField",
            }
        },
        {
            name: "secondApprover",
            label: "Second Approver",
            options: {
                filter: true,
                sort: false,
                filterType: "textField",
            }
        },
        {
            name: "active",
            label: "Status",
            options: {
                filter: true,
                filterList: ['Active'],
                sort: false,
                download: false,
            }
        },
        {
            name: "Edit",
            options: {
                filter: false,
                sort: false,
                download: false,
                empty: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <BorderColorIcon onClick={() => handleOpen(tableMeta.rowData[0])}
                                         className={classes.muiDataTableIcon}/>
                    );
                }
            }
        }
    ];

    return (
        <MuiThemeProvider theme={thisTheme}>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth={false} className={classes.container}>
                    {showCompetent ?
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography component="h1" variant="h5" align="left" style={{fontWeight: 600}}>
                                    Approver Config
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        title={"Employee List"}
                                        data={data}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                            <MultiSelctUpdate selectedEmployeeIDs={selectedEmployeeIDs}
                                              employeeApproverList={data}
                                              updateTable={updateTable}
                                              selectedEmployeeNames={selectedEmployeeNames}/>
                        </Grid>
                        :
                        <div className={classes.circularProgress}>
                            <CircularProgress/>
                        </div>
                    }
                </Container>
                {open && (
                    <Edit handleClose={handleClose} open={open} showId={showId}
                          updateApproverRecord={updateApproverRecord} backToTable={handleClose}/>
                )}
                <Dialog
                    open={submitCompletePopup}
                    onClose={handleCompletePopupClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Paper className={classes.afterSubmitPage}>
                        <IconButton aria-label="close" className={classes.closeButton}
                                    onClick={handleCompletePopupClose}>
                            <CloseIcon/>
                        </IconButton>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography style={{fontSize: '20px'}}>Edit Successful</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/>
                            </Grid>
                        </Grid>
                    </Paper>
                </Dialog>
            </main>
        </MuiThemeProvider>
    );
}
